import type { GetMbcCatalogResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { getCatalog } from "../api";

export function useMbcCatalog(): UseQueryResult<GetMbcCatalogResponse, Error> {
  return useQuery({
    queryFn: getCatalog,
    queryKey: mbcAdminKeys.catalog(),
  });
}
